import { render, staticRenderFns } from "./feedback-list.vue?vue&type=template&id=4e45c3a1"
import script from "./feedback-list.vue?vue&type=script&lang=js"
export * from "./feedback-list.vue?vue&type=script&lang=js"
import style0 from "./feedback-list.vue?vue&type=style&index=0&id=4e45c3a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports